(()=>{
  const norm=s=>(s||'').replace(/\s+/g,' ').trim();
  let videoDone=false,reviewDone=false,faqDone=false,queued=false,lastVideoTrigger=null;
  const mainHome=()=>[...document.querySelectorAll('.klx-home')].find(el=>el.querySelector('h1')&&el.querySelector('.klx-media-stage, #klx-amazon-videos'))||document.querySelector('.klx-home:not(.klx-faq-final-mount)');
  const showInserted=root=>{if(!root)return;root.querySelectorAll('[data-klx-add-reveal],.klx-reveal').forEach(el=>el.classList.add('is-in'))};

  const bindVideoUI=root=>{
    if(!root||root.dataset.klxVideoBound==='true')return;
    root.dataset.klxVideoBound='true';
    const modal=root.querySelector('[data-klx-video-modal]');
    const iframe=modal?.querySelector('[data-klx-video-iframe]');
    const title=modal?.querySelector('#klx-video-modal-title');
    if(!modal||!iframe)return;
    const closeVideo=()=>{iframe.src='';modal.hidden=true;document.documentElement.classList.remove('klx-video-modal-open');document.body.classList.remove('klx-video-modal-open');if(lastVideoTrigger){lastVideoTrigger.focus();lastVideoTrigger=null}};
    const openVideo=btn=>{const id=btn.dataset.klxVideoId;const videoTitle=btn.dataset.klxVideoTitle||'KLAXON Product Video';if(!id)return;lastVideoTrigger=btn;if(title)title.textContent=videoTitle;iframe.title=videoTitle;iframe.src=`https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;modal.hidden=false;document.documentElement.classList.add('klx-video-modal-open');document.body.classList.add('klx-video-modal-open');requestAnimationFrame(()=>modal.querySelector('.klx-video-modal__close')?.focus())};
    root.addEventListener('click',e=>{const play=e.target.closest('[data-klx-video-id]');if(play&&root.contains(play)){openVideo(play);return}if(e.target.closest('[data-klx-video-close]'))closeVideo()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)closeVideo()});
  };

  const enhanceVideo=()=>{
    if(videoDone)return true;
    const home=mainHome(),tpl=document.getElementById('klx-amazon-video-template');
    if(!home||!tpl)return false;
    const heading=[...home.querySelectorAll('h2')].find(h=>norm(h.textContent)==='Furniture with a Job to Do');
    const target=heading?.closest('.klx-section');
    const video=document.getElementById('klx-amazon-videos')||home.querySelector('.klx-media-stage')?.closest('.klx-section');
    if(!target||!video)return false;
    video.className='klx-section klx-section--cream klx-amazon-videos';video.id='klx-amazon-videos';video.setAttribute('aria-labelledby','klx-amazon-videos-title');video.innerHTML=tpl.innerHTML;target.insertAdjacentElement('afterend',video);bindVideoUI(video);showInserted(video);videoDone=true;return true;
  };

  const enhanceReviews=()=>{
    if(reviewDone)return true;
    const tpl=document.getElementById('klx-customer-review-template');
    const reviews=document.getElementById('klx-customer-feedback');
    if(!tpl||!reviews)return false;
    reviews.className='klx-add-section klx-add-section--soft klx-amazon-reviews klx-customer-reviews';
    reviews.setAttribute('aria-labelledby','klx-customer-review-title');
    reviews.innerHTML=tpl.innerHTML;
    showInserted(reviews);
    reviewDone=true;
    return true;
  };

  const moveFaq=()=>{
    if(faqDone)return true;
    const home=mainHome();if(!home)return false;
    const heading=[...home.querySelectorAll('h2')].find(h=>norm(h.textContent)==='Frequently Asked Questions');
    const faq=heading?.closest('.klx-section');if(!faq)return false;
    const mount=document.getElementById('klx-faq-final-mount');if(!mount){faq.style.display='none';faq.setAttribute('data-klx-faq-pending','true');return false}
    mount.appendChild(faq);faq.style.removeProperty('display');faq.removeAttribute('data-klx-faq-pending');showInserted(faq);faqDone=true;return true;
  };

  let observer;
  const run=()=>{queued=false;enhanceVideo();enhanceReviews();moveFaq();if(videoDone&&reviewDone&&faqDone&&observer)observer.disconnect()};
  const queue=()=>{if(queued)return;queued=true;requestAnimationFrame(run)};
  observer=new MutationObserver(queue);
  const start=()=>{run();if(!(videoDone&&reviewDone&&faqDone))observer.observe(document.body,{childList:true,subtree:true})};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
})();
